var $ = require(65);
require(95);
module.exports = function getOwnPropertyDescriptor(it, key){
  return $.getDesc(it, key);
};